import { render, staticRenderFns } from "./coreValuesMission.vue?vue&type=template&id=15300a89&scoped=true&"
import script from "./coreValuesMission.vue?vue&type=script&lang=js&"
export * from "./coreValuesMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15300a89",
  null
  
)

export default component.exports